import type { CheckCriterion, CheckResult } from "@/core/types";

export function pass(message: string, criteria?: CheckCriterion[]): CheckResult {
  return { passed: true, message, criteria };
}

export function fail(message: string, hint?: string, criteria?: CheckCriterion[]): CheckResult {
  return { passed: false, message, hint, criteria };
}

/**
 * Baut ein Prüfergebnis aus mehreren Teilkriterien. Nur wenn alle Kriterien
 * erfüllt sind, gilt die Aufgabe als bestanden.
 */
export function fromCriteria(
  criteria: CheckCriterion[],
  texts: { success: string; failure: string; hint?: string },
): CheckResult {
  const allPassed = criteria.every((criterion) => criterion.passed);
  return allPassed
    ? { passed: true, message: texts.success, criteria }
    : { passed: false, message: texts.failure, hint: texts.hint, criteria };
}

export function criterion(label: string, passed: boolean): CheckCriterion {
  return { label, passed };
}

/**
 * Ergebnis für Aufgaben, die diese Word-Version nicht prüfen kann.
 *
 * Ein Teil der Office.js-Schnittstellen steht erst ab höheren
 * Anforderungssätzen oder nur in der Desktop-Version zur Verfügung. Statt die
 * Aufgabe stillschweigend als bestanden zu werten, wird offen gesagt, dass die
 * Prüfung hier nicht möglich ist.
 */
export function unsupported(message: string, hint?: string): CheckResult {
  return { passed: false, unsupported: true, message, hint };
}
